import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { usePortalAuth } from '@/lib/portal-auth/usePortalAuth';
import { ClientUserRoleRank, type ClientUserRole } from '@/lib/portal-auth/types';

interface RequirePortalAuthProps {
  minRole?: ClientUserRole;
}

/**
 * Portal equivalent of <RequireAuth />. Gates /portal/* routes behind the
 * ClientUser session and redirects unauthenticated callers to /portal/login.
 */
export function RequirePortalAuth({ minRole = 'ClientViewer' }: RequirePortalAuthProps) {
  const { user, isAuthenticated, isBootstrapping } = usePortalAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <div className="grid min-h-screen place-items-center bg-background text-sm text-muted-foreground">
        Restoring session…
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/portal/login" replace state={{ from: location.pathname }} />;
  }

  if (ClientUserRoleRank[user.role] < ClientUserRoleRank[minRole]) {
    return <Navigate to="/portal" replace />;
  }

  return <Outlet />;
}
